module.exports = __webpack_public_path__ + "media/images/chat-9da6af8ea14ad47c3adef5d64762bbb4a927ce20df21718d93b5968ad2e736be.svg";